module.exports = __webpack_public_path__ + "static/media/redwoods1.43a8c14d.jpg";